import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services';

@Injectable()
export class PrintService {

    private printURL = environment.printURL + 'print';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }


    print(printerName: string, documentName: string) {
        return this.http.post(this.printURL + '/' + printerName + '/' + documentName, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.text();
        })
        .catch((error: any) => {

            return Observable.throw(new Error("Could not print"));
        });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/print/print.service.ts